import { Container } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { NextPage } from 'next';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';
import { useToast } from '@/hooks/useToast';

import { RemindPasswordForm } from '@/components/RemindPassword/RemindPasswordForm';
import { RemindPasswordSent } from '@/components/RemindPassword/RemindPasswordSent';
import Seo from '@/components/Seo';

import { AccountService } from '@/services/AccountService';

type RemindPasswordError = {
    code: string;
    location: string;
};

type RemindPasswordResponseError = {
    errors: RemindPasswordError[];
};

const RemindPassword: NextPage = () => {
    const [actionSuccessful, setActionSuccessful] = useState(false);
    const { errorToast } = useToast();
    const intl = useIntl();

    const remindPasswordFormSubmit = (memberNumber: string) => {
        AccountService.remindPassword(memberNumber)
            .then(() => {
                setActionSuccessful(() => true);
            })
            .catch((response: AxiosError<RemindPasswordResponseError>) => {
                const { errors } = response.response?.data || ({} as RemindPasswordResponseError);
                let errorMessage = intl.formatMessage({ id: 'password-cannot-be-reset' });

                if (errorMessage.length) {
                    errorMessage += `. ${intl.formatMessage({ id: errors?.[0].code })}`;
                }
                errorToast({
                    description: errorMessage
                });
            });
    };

    return (
        <>
            <Seo templateTitle={intl.formatMessage({ id: 'page.remind-password.title' })} />
            <Container maxW="site">
                {actionSuccessful ? (
                    <RemindPasswordSent />
                ) : (
                    <RemindPasswordForm onSubmit={remindPasswordFormSubmit} />
                )}
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps();

export default RemindPassword;
